module.exports = __webpack_public_path__ + "img/bottom.1d7a5116.png";